import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InterventionFileProjectState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: InterventionFileProjectState = {
  data: [],
  isLoading: false,
  error: null,
};

const InterventionFileProjectSlice = createSlice({
  name: 'InterventionFileProject',
  initialState,
  reducers: {
    setInterventionProjectFiles: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setInterventionFileProjectLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setInterventionFileProjectError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setInterventionProjectFiles, setInterventionFileProjectLoading, setInterventionFileProjectError } =
  InterventionFileProjectSlice.actions;

export default InterventionFileProjectSlice.reducer;
